import genericContentItemAnswer
  from '@shared/components/mixins/genericContentItemAnswer'
import pxToEm from '@shared/components/mixins/shared/pxToEm'

export default {
  name: 'CheckboxComponent',
  mixins: [genericContentItemAnswer, pxToEm],
  props: {
    component: {
      type: Object,
      required: true,
    },
    validation: {
      type: Object,
      required: false,
    },
  },
  computed: {
    uniqueId() {
      return `checkbox-${this.component.id}-${this._uid}`
    },
    checkBoxText() {
      const asteriskPattern = /\*<\/p>$/ // Pattern to check if asterisk exists before </p>
      let checkboxText = this.component.content.text

      if (this.component.settings.required) {
        // If 'value' is true and the asterisk is not already present, add an asterisk
        if (!asteriskPattern.test(checkboxText)) {
          checkboxText = checkboxText.replace(
            /<\/p>$/, '*</p>')
        }
      }

      return checkboxText
    },
    computedCheckboxContainerStyle() {
      let style = {
        borderWidth: this.emStyling.borderWidth,
        borderRadius: this.emStyling.borderRadius,
        borderColor: this.emStyling.borderColor,
        backgroundColor: this.emStyling.backgroundColor,
      }

      if (this.emStyling.align === 'left') {
        style = { ...style, justifyContent: 'flex-start' }
      } else if (this.emStyling.align === 'right') {
        style = { ...style, justifyContent: 'flex-end' }
      } else if (this.emStyling.align === 'center') {
        style = { ...style, justifyContent: 'center' }
      }

      return style
    },
  },
  methods: {
    triggerInputChange() {
      this.$eventBus.$emit('checkbox-answer', this.answer)
    },
  },
}
